import type React from 'react';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { transformHashRoute } from 'utils/RouteUtil';

interface VerifyAccessProps {
  defaultPath: string;
}

const VerifyAccess: React.FC<VerifyAccessProps> = ({ defaultPath }) => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.hash) {
      navigate(transformHashRoute({ location }));
    } else {
      navigate(defaultPath);
    }
  }, [defaultPath, location, navigate]);

  return null;
};

export default VerifyAccess;
